import type { MailContentProps, MailMetadata } from "../../lib/types";
import { MailSignature } from "../mail/mail-signature";

function RefusDematerialisationTechnique({ variablesData }: MailContentProps) {
  return (
    <div className="space-y-2">
      <p>
        J'ai trouvé ce brouillon dans la boite mail de{" "}
        {variablesData.genre_masc_abrege}{" "}
        {variablesData.responsable_grand_est_precedent_nom}.
      </p>
      <p>Voulez vous transmettre cet e-mail avec votre adresse ?</p>
      <MailSignature
        emetteurLogo={RefusDematerialisationTechnique.metadata.emetteurLogo}
        emetteur={RefusDematerialisationTechnique.metadata.emetteur}
        emetteurPoste={RefusDematerialisationTechnique.metadata.emetteurPoste}
        emetteurEntreprise={
          RefusDematerialisationTechnique.metadata.emetteurEntreprise
        }
      />
      <div className="mt-6">
        <div className="italic">Message transféré :</div>
        <div className="mt-2 space-y-4 border-l-4 border-gray-300 pl-4 text-gray-600">
          <p>
            {variablesData.genre_masc_complet}{" "}
            {variablesData.collaborateur_1_nom},
          </p>
          <p>
            Les implications, en termes de surcroît de travail, de votre
            programme d'informatisation de la gestion du personnel (nécessité de
            créer un poste supplémentaire pour pérenniser le système) ont
            conduit à l'abandon de ce projet.
          </p>
          <p>
            Face à ce constat, je ne peux pas vous autoriser à mener cette
            nouvelle action d'informatisation de la gestion des ouvrages,
            opération qui pourrait encore se solder par un échec.
          </p>
          <div>
            <p className="py-0 font-bold">
              {variablesData.responsable_grand_est_precedent_prenom}{" "}
              {variablesData.responsable_grand_est_precedent_nom}
            </p>
            <p>{variablesData.responsable_grand_est_precedent_fonction}</p>
            <p>{variablesData.responsable_grand_est_precedent_societe}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

RefusDematerialisationTechnique.metadata = {
  titre: "Refus dématérialisation de la documentation technique",
  cleMail: "refus_dematerialisation_documentation_technique",
  messageTransfert: true,
  emetteur: "Nicole SON",
  emetteurPoste: "Assistante de direction",
  emetteurEntreprise: "SYTEL Grand Est",
  emetteurLogo: "/logos/sytel_grand_est.png",
  dateRelative: 0,
  piecesJointes: [],
} as MailMetadata;

export default RefusDematerialisationTechnique;
